module.exports = __webpack_public_path__ + "cc6256c3d16aaf23414275f3238c71c4.pdf";